/**
 * The scoring engine's vocabulary.
 *
 * Everything here is plain data. No classes, no methods, no I/O — the engine is
 * a pure function from (state, command) to state, which is what makes it
 * testable in milliseconds and identical on the server and in the browser.
 */
/* ── refusals ───────────────────────────────────────────────────────────── */
/**
 * The engine refuses illegal cricket by throwing. Every code is a thing a
 * scorer can act on — the message is written for the person holding the phone,
 * not for a log file.
 */
export class RuleViolation extends Error {
    code;
    constructor(code, message) {
        super(message);
        this.code = code;
        this.name = "RuleViolation";
    }
}
//# sourceMappingURL=types.js.map